var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"org-logo-small"},[_c('div',{class:_vm.theme},[_c('img',{attrs:{"src":_vm.url + _vm.OrganizationLogo.objectKey,"height":"35"}}),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.pageTitle))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-132731b2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrgLogo.vue
// module id = 1072
// module chunks = 1